// slide from left
// document.addEventListener("DOMContentLoaded", function () {
//   const targets = document.querySelectorAll('.animation-fromLeft');

//   if (!targets.length) return;

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         const el = entry.target;
//         el.classList.remove('animate'); // Reset animation
//         void el.offsetWidth; // Force reflow
//         el.classList.add('animate');
//       }
//     });
//   }, {
//     threshold: 0.5
//   });

//   targets.forEach(el => observer.observe(el));
// });

document.addEventListener("DOMContentLoaded", function () {
  const targets = document.querySelectorAll('.animation-fromLeft');

  if (!targets.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;

      if (entry.isIntersecting) {
        el.classList.remove('slide-out'); // Remove exit animation
        void el.offsetWidth;              // Force reflow
        el.classList.add('animate');     // Trigger entrance animation
      } else {
        el.classList.remove('animate');  // Remove entrance animation
        void el.offsetWidth;
        el.classList.add('slide-out');   // Trigger exit animation
      }
    });
  }, {
    threshold: 0.5
  });

  targets.forEach(el => observer.observe(el));
});


// animations from right
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.animation-fromRight');
  if (!targets.length) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const target = entry.target;

      if (entry.isIntersecting) {
        target.classList.remove('slide-out');     // remove exit animation
        void target.offsetWidth;                  // force reflow
        target.classList.add('animate');          // trigger entrance animation
      } else {
        target.classList.remove('animate');       // remove entrance animation
        void target.offsetWidth;
        target.classList.add('slide-out');        // trigger exit animation
      }
    });
  }, { threshold: 0.2 });

  targets.forEach(target => observer.observe(target));
});




window.addEventListener('scroll', function () {
  const section = document.querySelector('.scrollss');
  if (!section) return;

  const rect = section.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  if (rect.top < windowHeight && rect.bottom > 0) {
    const visiblePortion = Math.max(0, Math.min(1, 1 - rect.top / windowHeight));

    // Amplify movement speed (e.g., 120 instead of 100)
    const posX = visiblePortion * 80;

    section.style.backgroundPositionX = `${posX}%`;
    section.style.backgroundPositionY = `center`;
  }
});







